import { graphqlApolloClient } from "../graphql-apollo-client"
import { GET_PROJECT_BENEFICIARIES_BY_PROJECT } from "./graphql/queries/getBeneficiariesByProject"

export const getProjectBeneficiariesByProject = async ({ id }) => {
  const { data } = await graphqlApolloClient.query({
    query: GET_PROJECT_BENEFICIARIES_BY_PROJECT,
    fetchPolicy: "network-only",
    variables: {
      id
    }
  })

  return data?.ProjectBeneficiariesByProject
}